/**
 * @file src/_modulos/financeiro/listagem/columns/components/status.tsx
 * @description Componentes e funções relacionadas ao status das faturas
 */

"use client";

import { IconCheck, IconFileText } from "@tabler/icons-react";
import {
  BadgePreset,
  CategoryConfig,
  createIconOnlyPreset,
  createEmptyPreset,
  createInvalidPreset,
} from "@PN/tabela";

/**
 * Configuração das categorias de status
 */
const STATUS_CATEGORIES: Record<string, CategoryConfig> = {
  aprovado: {
    color: "text-lime-600 dark:text-lime-400",
    icon: IconCheck,
    getTooltip: () => "Status: Aprovado – fatura aprovada e processada.",
  },
  incluida: {
    color: "text-amber-600 dark:text-amber-400",
    icon: IconFileText,
    getTooltip: () => "Status: Incluída – fatura incluída no sistema.",
  },
} as const;

/**
 * Valores válidos para status
 */
const VALID_STATUSES = ["Aprovado", "Incluída"];

/**
 * Obtém preset de status
 */
export function getStatusPreset(s?: string | null): BadgePreset {
  const key = s?.trim() ?? "";

  if (!key) {
    return createEmptyPreset(<span>Sem Status</span>, "Status não definido.");
  }

  // Normalizar entrada
  const normalizedKey = key.toLowerCase();
  const categoryKey = normalizedKey as keyof typeof STATUS_CATEGORIES;

  if (!STATUS_CATEGORIES[categoryKey]) {
    return createInvalidPreset(key, VALID_STATUSES, "Inválido");
  }

  const config = STATUS_CATEGORIES[categoryKey];
  return createIconOnlyPreset(config, config.color);
}
